import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import initialStyles from '../settings/initialStyles';
import { linkIcons, linkText } from '../settings/linkData';
import ThemeConfigPanel from '../settings/ThemeConfigPanel';
import Notification from '../components/notification/Notification'; // Ensure correct import path

import 'react-circular-progressbar/dist/styles.css';
import '../styles/TemplateTwo.css';

const themePresets = {
    default: initialStyles,
    dark: {
        backgroundColor: '#333',
        secondaryBackgroundColor: '#555',
        headerBackgroundColor: '#222',
        headerTextColor: '#fff',
        subheaderTextColor: '#555',
        textColor: '#eee',
        headerFontSize: '1.6',
        subheaderFontSize: '1.5',
        bodyFontSize: '1'
    },
    light: {
        backgroundColor: '#f9f9f9',
        secondaryBackgroundColor: '#e0e0e0',
        headerBackgroundColor: '#ddd',
        headerTextColor: '#333',
        subheaderTextColor: '#555',
        textColor: '#111',
        headerFontSize: '1.6',
        subheaderFontSize: '1.5',
        bodyFontSize: '1'
    }
};

const ViewTemplateTwo = ({ template, isDownloading }) => {
    const [styles, setStyles] = useState(initialStyles);
    const [notification, setNotification] = useState(null);

    const handleStyleChange = (e) => {
        const { name, value } = e.target;
        setStyles((prevStyles) => ({
            ...prevStyles,
            [name]: value,
        }));
    };

    const applyPreset = (preset) => {
        setStyles(themePresets[preset]);
    };

    const saveCustomTheme = () => {
        localStorage.setItem('customTheme', JSON.stringify(styles));
        setNotification({ message: 'Custom theme saved!', isError: false });
    };

    const loadCustomTheme = () => {
        const customTheme = localStorage.getItem('customTheme');
        if (customTheme) {
            setStyles(JSON.parse(customTheme));
            setNotification({ message: 'Custom theme loaded!', isError: false });
        } else {
            setNotification({ message: 'No custom theme found!', isError: true });
        }
    };

    const templateData = template || {};

    const skillsWithLevels = (templateData?.skills || []).map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 11) + 90

    }));

    const softwareSkillsWithLevels = (templateData?.softwareSkills || []).map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 11) + 90

    }));

    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://venusresume.vercel.app/';
    const imageUrl = templateData?.image?.startsWith('/')
        ? `${baseUrl}${templateData.image}`
        : templateData.image;

    return (
        <div className='holder'>

            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}

            <div className="template-two-container" style={{ backgroundColor: styles.backgroundColor }}>
                <div className='image' style={{ backgroundColor: styles.headerBackgroundColor }}>
                    {imageUrl && <img src={imageUrl} alt={template?.personName} className="template-two-image" />}
                </div>
                <div className="template-two-content-wrapper">
                    <div className="template-two-sidebar" style={{ backgroundColor: styles.secondaryBackgroundColor }}>

                        {template?.personName && <h1 className="template-two-name" style={{ fontSize: `${styles.headerFontSize}em`, color: styles.headerTextColor }}>{template?.personName}</h1>}

                        {template?.contact && (
                            <div className="template-two-contact">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Contact:</strong>
                                {templateData.contact.email && <p><FontAwesomeIcon icon={faEnvelope} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {templateData.contact.email}</p>}
                                {templateData.contact.phone && <p><FontAwesomeIcon icon={faPhone} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {templateData.contact.phone}</p>}
                                {templateData.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {templateData.contact.address}</p>}
                            </div>
                        )}

                        <div>
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}> About Me</strong>
                            {templateData.aboutMe && <p className="template-two-about" style={{ fontSize: `${styles.bodyFontSize}em`, color: styles.textColor }}>{templateData.aboutMe}</p>}
                        </div>

                        {templateData?.languages && (
                            <div className="template-two-languages">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faLanguage} /> Languages:</strong> {templateData.languages.join(', ')}
                            </div>
                        )}


                        {templateData?.skills && (
                            <div className="template-two-skills template-section">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Skills</strong>
                                <div className="skills-wrapper">
                                    {skillsWithLevels.map((skill, index) => (
                                        <div key={index} className="skill-item">
                                            <p style={{ fontSize: `${styles.bodyFontSize}em` }}>{skill.name}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {templateData?.skills && (
                            <div className="template-two-skills template-section">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Software Skills</strong>
                                <div className="skills-wrapper">
                                    {softwareSkillsWithLevels.map((skill, index) => (
                                        <div key={index} className="skill-item">
                                            <p style={{ fontSize: `${styles.bodyFontSize}em` }}>{skill.name}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {templateData.hobbies && (
                            <div className="template-two-hobbies">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faHeart} /> Hobbies:</strong> {templateData.hobbies.join(', ')}
                            </div>
                        )}
                    </div>
                    <div className="template-two-main-content">
                        {templateData.workExperience && templateData.workExperience.length > 0 && (
                            <div className="template-two-work-experience">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faBriefcase} /> Work Experience</strong>
                                {templateData.workExperience.map((experience, index) => (
                                    <div key={index} className="template-two-work-experience-item">
                                        {experience.role && <p className="template-two-role" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.role} at {experience.company}</p>}
                                        {experience.location && (
                                            <p className="template-two-location" style={{ fontSize: `${styles.bodyFontSize}em` }}>
                                                {experience.location} (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                        {experience.description && <p className="template-two-description" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.description}</p>}
                                    </div>
                                ))}
                            </div>
                        )}
                        {templateData.education && Array.isArray(templateData.education) && templateData.education.length > 0 && (
                            <div className="template-two-education">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faGraduationCap} /> Education</strong>
                                {templateData.education.map((edu, index) => (
                                    <div key={index} className="template-two-education-item" >
                                        {edu.degree && <p className="template-two-degree" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.degree} from {edu.institution}</p>}
                                        <p style={{ fontSize: `${styles.bodyFontSize}em`, fontWeight: "200" }}>
                                            (
                                            {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                        {edu.description && <p className="template-two-description" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.description}</p>}
                                    </div>
                                ))}
                            </div>
                        )}

                        {templateData?.certificates && templateData.certificates.length > 0 && (
                            <div className="template-two-education">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faGraduationCap} /> Certificates </strong>
                                {templateData.certificates.map((certification, index) => (
                                    <div key={index} className="template-two-education-item" >
                                        {certification.title && <p className="template-two-degree" style={{ fontSize: `${styles.bodyFontSize}em` }}>Title: {certification.title}</p>}
                                        {certification.institution && <p style={{ fontSize: `${styles.bodyFontSize}em`, fontWeight: "300" }}>Institution: {certification.institution}</p>}
                                        {certification.DateReceived && (
                                            <p style={{ fontSize: `${styles.bodyFontSize}em`, fontWeight: "200" }}>
                                                Date Received: {new Date(certification.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}                                            </p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {templateData.links && (
                            <div className="template-two-links">
                                <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Links:</strong>
                                {Object.entries(templateData.links).map(([key, value]) => (
                                    <p key={key} className="template-two-link">
                                        <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer" style={{ fontSize: `${styles.bodyFontSize}em` }}>{linkText[key]}</a>
                                    </p>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {!isDownloading && (
                <ThemeConfigPanel
                    styles={styles}
                    handleStyleChange={handleStyleChange}
                    applyPreset={applyPreset}
                    saveCustomTheme={saveCustomTheme}
                    loadCustomTheme={loadCustomTheme}
                />
            )}
        </div>
    );
};

export default ViewTemplateTwo;
